import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  pushBreadcrumbItem,
  resetBreadcrumb,
  popBreadcrumbItem,
} from 'src/redux/Actions/Breadcrumb';

const normalize = (str) => str.replace(/^\/|\/$/g, '');

const rootRoutes = new Set(
  [
    '/',
    '/dashboard',
    'settings/',
    'tenant-management/',
    'stations/',
    'report/',
    'report/variance/',
    'report/vehicle-trackings/',
    'report/inward/',
    'report/inward-with-exit-time/',
    'vehicle-tracking/create/',
    'grn/list',
    'outward/planning/',
    'test1/',
    'test2/',
    'station-activity-logs/',
  ].map(normalize),
);

const DASHBOARD_ENTRY = {
  pathname: '/',
  label: 'Dashboard',
  breadcrumbReducer: ['Dashboard'],
};

export const useSetBreadcrumbData = (pathname, label) => {
  const dispatch = useDispatch();
  const breadcrumbItems = useSelector(
    (state) => state.breadcrumbReducer.breadcrumbItems,
  );

  useEffect(() => {
    if (!pathname || !label) return;

    const normalizedPath = normalize(pathname);
    const isRoot = rootRoutes.has(normalizedPath);

    if (isRoot) {
      dispatch(resetBreadcrumb(true));
      dispatch(pushBreadcrumbItem(DASHBOARD_ENTRY));
      dispatch(
        pushBreadcrumbItem({
          pathname,
          label,
          breadcrumbReducer: [label],
        }),
      );
      return;
    }

    const alreadyExistsIndex = breadcrumbItems.findIndex(
      (item) => item.label === label,
    );

    if (alreadyExistsIndex !== -1) {
      for (let i = breadcrumbItems.length - 1; i > alreadyExistsIndex; i -= 1) {
        dispatch(popBreadcrumbItem({ pathname: breadcrumbItems[i]?.pathname }));
      }
      return;
    }

    dispatch(
      pushBreadcrumbItem({
        pathname,
        label,
        breadcrumbReducer: [label],
      }),
    );
  }, [pathname, label, dispatch]);

  useEffect(() => {
    const isExceedingSize = breadcrumbItems.length >= 4;
    if (isExceedingSize) {
      dispatch(
        popBreadcrumbItem({
          pathname: breadcrumbItems[0].pathname,
          mode: 'shiftFirst',
        }),
      );
    }
  }, [breadcrumbItems]);
};
